exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "h6{margin-right:10px}.destroyButton{margin:0px 10px 0px 0px}.backToReviewButton{margin:0 10px 0 0px}img{opacity:1}div.card.header{font-size:24px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Review/Review.scss
// module id = 262
// module chunks = 0